import apiClient from './api'
import type { LoginRequest, User } from '@/types/api.types'

export const authService = {
    /**
     * Login user
     * Token is handled via HttpOnly Cookie by the server
     */
    async login(credentials: LoginRequest): Promise<User> {
        const response = await apiClient.post<{ user: User }>('/api/v1/auth/login', credentials)
        if (response.data.user) {
            localStorage.setItem('user', JSON.stringify(response.data.user))
        }
        return response.data.user
    },

    /**
     * Get current user profile
     * Checks session validity via Cookie
     */
    async getCurrentUser(): Promise<User> {
        const response = await apiClient.get<User>('/api/v1/auth/me')
        localStorage.setItem('user', JSON.stringify(response.data))
        return response.data
    },

    /**
     * Logout user
     * Clears cookie on server side
     */
    async logout(): Promise<void> {
        try {
            await apiClient.post('/api/v1/auth/logout')
        } finally {
            localStorage.removeItem('user')
        }
    },

    /**
     * Check if user is authenticated (locally)
     * For accurate check, call getCurrentUser()
     */
    isAuthenticated(): boolean {
        return !!localStorage.getItem('user')
    },

    /**
     * Get list of active devices (Admin)
     */
    async getDevices(): Promise<any[]> {
        const response = await apiClient.get<any[]>('/api/v1/admin/devices')
        return response.data
    },

    /**
     * Revoke device access
     */
    async revokeDevice(id: string): Promise<void> {
        await apiClient.delete(`/api/v1/admin/devices/${id}`)
    }
}
